import client from './client';

export const listWeeklyWeeks = () => client.get('/weekly-report/weeks').then((r) => r.data);
export const getWeeklyWeek = (weekKey) => client.get(`/weekly-report/week/${weekKey}`).then((r) => r.data);
export const getWeeklyDeadline = () => client.get('/weekly-report/deadline').then((r) => r.data);
export const setWeeklyDeadline = (weekday, time) =>
  client.put('/weekly-report/deadline', { weekday, time }).then((r) => r.data);

// GĐ/CV xoá báo cáo tuần của 1 phòng (key: 'kd:<tênNhóm>' | 'finance' | 'cskh' | 'purchase') để làm lại.
export const resetWeeklyDept = (weekKey, key) =>
  client.delete(`/weekly-report/week/${weekKey}/dept/${encodeURIComponent(key)}`).then((r) => r.data);
